import styled from 'styled-components';

export default styled.p`
  ${props => props}
  color: ${props => props.theme.old.colors[props.color] || props.theme.old.colors.white};
  font-family: ${props => props.theme.old.fonts.family[props.family] || props.theme.old.fonts.family.primary};
  font-size: ${props => props.theme.old.fontSize[props.size] || props.theme.old.fontSize.text};
  font-weight: ${props => props.theme.old.fonts.weight[props.weight] || props.theme.old.fonts.weight.regular};
  transition: ${props => props.transition && props.theme.old.transition.default};
  text-align: ${props => props.align};
  line-height: ${props => props.lineHeight || props.theme.old.fontSize.title};

  :hover{
    color: ${props => props.theme.old.colors[props.hoverColor]};
  }
`;